<template>
  <v-dialog v-model="selectConsumerDialog" max-width="600" scrollable>
    <v-card>
      <v-card-title>{{ consumers.length >= 1 ? 'Selecione um consumidor' : 'Nenhum resultado' }}</v-card-title>
      <v-card-text v-if="consumers.length <= 0" class="py-4">
        <div class="d-flex flex-column align-center">
          <mf-icon large>info</mf-icon>
          <span>Consumidor não cadastrado no clube ou não localizado</span>
        </div>
      </v-card-text>
      <v-card-text v-else>
        <span>{{ consumers.length }} consumidores encontrados. Por favor, escolha o correspondente a sua busca:</span>
        <div class="consumer-container my-2">
          <DynamicScroller
            v-if="consumers.length"
            v-slot="{ item, index, active }"
            class="vue-recycle-scroller scroller ready direction-vertical"
            :items="consumers"
            :min-item-size="30"
            key-field="id"
          >
            <DynamicScrollerItem :item="item" :active="active" :data-index="index">
              <v-list-item class="list-consumer-item" @click="selectConsumer(item)">
                <v-list-item-content>
                  <div class="d-flex flex-row align-center" style="gap: 8px">
                    <mf-icon large :fill="!item.isTemp">person</mf-icon>
                    <div class="d-flex flex-column" style="gap: 4px">
                      <span v-if="item.name" class="bold">{{ item.name | pii(hasPiiAccess) }}</span>
                      <span v-else class="bold">Pré-cadastro</span>
                      <span><span class="cinza-0-text">Documento: </span>{{ item.documentNo | cpfCnpj | pii(hasPiiAccess, 'document') }}</span>
                      <span><span class="cinza-0-text">Telefone: </span>{{ item.phone | telefone | pii(hasPiiAccess, 'phone') }}</span>
                    </div>
                  </div>
                </v-list-item-content>
                <v-list-item-action>
                  <mf-icon>chevron_right</mf-icon>
                </v-list-item-action>
              </v-list-item>
            </DynamicScrollerItem>
          </DynamicScroller>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: handleClose,
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    DynamicScroller,
    DynamicScrollerItem,
  },
  props: {
    consumers: {
      type: Array,
      required: true,
    },
  },
  emit: {
    selectConsumer: null,
  },
  data: () => ({
    selectConsumerDialog: false,
  }),
  methods: {
    handleClose() {
      this.selectConsumerDialog = !this.selectConsumerDialog
    },
    selectConsumer(consumer) {
      this.$emit('selectConsumer', consumer)
      this.handleClose()
    },
  },
}
</script>

<style lang="scss" scoped>
.scroller {
  height: 100%;
  overflow-y: auto;
}

.list-consumer-item {
  padding: 0 8px !important;
  border-bottom: 1px dotted $cinza-l70;
}

.cinza-0-text {
  color: $cinza-0;
}
</style>
